/**
 * Used to removes commas from number/currency values to prevent issues when concatenating events in the event string
 * @param:(string) str - object to strip commas from
 * @returns: (string) - str string with all commas removed
 */
var stripComma = function ( str ) {

    str = ( typeof str !== 'undefined' ? str : '' );

    // handle the case when value is passed in as "number" type
    str = ( typeof str === 'number' ? str.toString() : str );

    if ( typeof str === "string" ) {
        str = str.replace( /,/g, "" );
    }

    return str;
};

/**
 * This was done in daCaller, so bringing this bit forward until we can determine whether it is needed
 * @param (string) ddo - digital data object
 * @param (string) idx  - index of the event being processed (if any)
 * @returns {*}
 */
var getEventItemForProdString = function ( ddo, idx ) {
    var de_evI, de_evItms;
    if ( ddo.event && idx !== undefined ) {
        de_evI = ddo.event[ idx ];
        de_evItms = de_evI ? de_evI.item ? de_evI.item : de_evI.eventInfo ? de_evI.eventInfo.items : [] : [];
    }
    return ( de_evItms ? de_evItms : undefined );
};

/**
 *
 * @param:
 * @returns:
 */
var getFulfillString = function ( prodArray ) {
    var aProd, aProdInfo, aProdMethod, aFulfil, product,
        dti = digitalData.transaction.item,
        dci = digitalData.cart.item,
        itemArray = prodArray ? prodArray : dti && dti.length ? dti : dci && dci.length ? dci : [],
        fulfillStr,
        fulfillData = {
            'STH': 'n',
            'BOPIS': 'n',
            'BOSS': 'n',
            'APPL': 'n',
            'BODFS': 'n'
        },
        ddoFound = false;
    for ( product in itemArray ) {
        if ( itemArray.hasOwnProperty( product ) ) {
            aProd = itemArray[ product ];
            aProdInfo = aProd.productInfo;

            // normalize item[n].fullfillment
            aFulfil = aProd.fulfillment ? aProd.fulfillment : {};
            if ( typeof ( aFulfil.method ) === 'undefined' ) { // Should we check for empty string here to take the first populated value??
                if ( aProd.fulfillmentMethod ) {
                    aFulfil.method = aProd.fulfillmentMethod;
                }
                else if ( aProdInfo && aProdInfo.fulfillmentMethod ) {
                    aFulfil.method = aProdInfo.fulfillmentMethod;
                }
                else {
                    aFulfil.method = 0;
                }
            }

            aProdMethod = ( typeof ( aFulfil.method ) === 'string' ? aFulfil.method.toUpperCase() : aFulfil.method );

            if ( aProdMethod === 0 ) {
                continue;
            }
            
            fulfillData[ aProdMethod ] = 'y';
            ddoFound = true;
        }
    }

    if ( ddoFound ) {
        fulfillStr = JSON.stringify( fulfillData ).replace( /[{}"]/g, '' ).replace( /,/g, '|' );
    }

    return fulfillStr;
};

/**
 * Ensure w is removed from cart id
 * @param:
 * @returns:
 */
var formatCartID = function ( ddo, cartID ) {
    cartID = ( typeof cartID !== "undefined" && cartID ? cartID.toString() : ddo.cart && ddo.cart.cartID ? ddo.cart.cartID.toString() : "" );

    if ( cartID && cartID.substring( 0, 1 ) && cartID.substring( 0, 1 ).toLowerCase().indexOf( "w" ) === 0 ) {
        cartID = cartID.toString().replace( /w/, "" );
    }

    return cartID;
};

/**
 * Format an ATC Location Object for setting into eVar53
 * @param:
 * @returns:
 */
var formatATCLocation = function ( ddo, locObj ) {

    var result = "",
        pt = ( ddo && ddo.page && ddo.page.pageInfo && ddo.page.pageInfo.pageType ? ddo.page.pageInfo.pageType : "n/a" );

    if ( typeof locObj !== "undefined" ) {

        result = ( locObj.pageType ? locObj.pageType : pt ) + ">" +
            ( locObj.sharedSection ? locObj.sharedSection : "n/a" ) + ">" +
            ( locObj.section ? locObj.section : "n/a" ) + ">" +
            ( locObj.component ? locObj.component : "n/a" ) + ">" +
            ( locObj.target ? locObj.target : "n/a" ) + ">n/a";
    }

    return result;
};

/**
 * Format an Pod Click Object for setting into eVar150
 * @param:
 * @returns:
 */
var formatPodClick = function ( podClickObj, defaultText = 'n/a' ) {

    var result = "",
		prodSponsored = ( typeof ( podClickObj.sponsoredProduct ) !== 'undefined' && podClickObj.sponsoredProduct.toString() === "true" ? true : false);

    if ( typeof podClickObj !== "undefined" ) {

        result = ( typeof ( podClickObj.podPageNumber ) !== 'undefined' ? podClickObj.podPageNumber : defaultText ) + "-" +
            ( typeof ( podClickObj.podPosition ) !== 'undefined' ? podClickObj.podPosition : defaultText ) + ( prodSponsored ? ">sponsored:true" : ">sponsored:false" );
    }

    return result;
};

/**
 * Format search/browse filters, used to populate v18/v29/c16
 * @param:
 * @returns:
 */
var formatSearchBrowseFilters = (filters = [], delim = ",") => {

    if ( !filters.length ) { return ""; }

    let result = [];

    filters.forEach((filter) => {
        result.push(`${filter.filterType ? filter.filterType : ""}:${filter.type ? filter.type : ""}:${filter.value ? filter.value : ""}`);
    });

    return result.join( delim );

}
/*grabs all the skus for eVar103*/
var getContentSku = function ( ddo ) {
    var contentSku = ( typeof ( ddo ) !== "undefined" && ddo.content && ddo.content.product ? ddo.content.product : [] ),
        skuList = [];
    for ( var i = 0; i < 24; i++ ) {
        if ( i < contentSku.length ) {
            skuList.push( contentSku[ i ].productInfo.sku );
        }
        else {
            skuList.push( "" );
        }
    }

    return skuList.join( "|" );
};

export {
    formatATCLocation,
    formatCartID,
    formatPodClick,
    formatSearchBrowseFilters,
    getContentSku,
    getEventItemForProdString,
    getFulfillString,
    stripComma
};
